import { render, staticRenderFns } from "./appaymplanfrm.vue?vue&type=template&id=22029528"
import script from "./appaymplanfrm.vue?vue&type=script&lang=js"
export * from "./appaymplanfrm.vue?vue&type=script&lang=js"
import style0 from "./appaymplanfrm.vue?vue&type=style&index=0&id=22029528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports